export function getRoleFromDomain(): "teacher" | "student" {
  const hostname = window.location.hostname
  const parts = hostname.split(".")

  let role: "teacher" | "student" = "teacher"

  if (parts[0] == "student") {
    role = "student"
  }

  return role
}

// SSO cookies (auth_data) are set by the backend with a leading-dot Domain
// (e.g. ".classbank.com" in prod, ".classbank.applover.dev" in staging) so
// they're readable across the teacher./student. subdomains. Cookies.remove
// needs that same Domain attribute to actually delete the cookie -- without
// it the removal silently no-ops and the cookie lingers.
export function getAuthCookieDomain(): string | undefined {
  if (process.env.REACT_APP_DOMAIN_SPLIT !== "1") {
    return undefined
  }

  const parts = window.location.hostname.split(".")
  if (parts.length < 2) {
    return undefined
  }

  return `.${parts.slice(1).join(".")}`
}
